/**
 * Belt hierarchy constants — single source of truth for the frontend.
 * Import from here instead of defining ['white', 'blue', ...] inline.
 */

export const BELT_ORDER = ['white', 'blue', 'purple', 'brown', 'black'] as const;

export type BeltColor = typeof BELT_ORDER[number];

export const getBeltIndex = (belt: string): number =>
  BELT_ORDER.indexOf(belt as BeltColor);

export const isHigherBelt = (a: string, b: string): boolean =>
  getBeltIndex(a) > getBeltIndex(b);

export const isValidBeltColor = (belt: string): belt is BeltColor =>
  BELT_ORDER.includes(belt as BeltColor);
